import VehicleTypeMarginCell from "./VehicleTypeMarginCell";


export const NO_LOT_SELECTED_TEXT = "Please select a lot to view pricing data";
export const NO_ITEMS_MESSAGE = "There are no pricing data matching this criteria";
export const DEFAULT_LABEL = "Default";
export const UNKNOWN_VENDOR_LABEL = "Unknown Vendor";
export const FLAT_RATE_LABEL = "Flat Rate";
export const VARIES_BY_VEHICLE_TYPE_LABEL = "Varies by vehicle type";
export const TOOLTIP_TITLE = "Vendor Cost by Vehicle Type";
export const ALL_CLIENTS_LABEL = "All Clients";

export const columns = [
	{
		name: "Activity",
		sortKey: "activityName",
		key: "activityName",
		component: (row) => <div>{row?.activityName}</div>,
	},
	{
		name: "Vendor Cost",
		sortKey: "vendorCost",
		key: "vendorCost",
		component: (row) => <div>{row?.formattedVendorCost}</div>,
	},
	{
		name: "Client",
		sortKey: "clientDisplayName",
		key: "clientDisplayName",
		component: (row) => <div>{row?.clientDisplayName}</div>,
	},
	{
		name: "Vehicle Type Margin",
		sortKey: "vehicleTypeMargin",
		key: "vehicleTypeMargin",
		component: (row) => <VehicleTypeMarginCell row={row}/>,
	},
];

export const groupRowsByVendor = (rows = []) => {
	const groupsMap = {};
	const groupedRows = [];

	rows.forEach((row) => {
		const vendorName = row?.vendorDisplayName ?? UNKNOWN_VENDOR_LABEL;
		if (!groupsMap[vendorName]) {
			groupsMap[vendorName] = { vendorName, rows: [] };
			groupedRows.push(groupsMap[vendorName]);
		}
		groupsMap[vendorName].rows.push(row);
	});

	return groupedRows;
};

export const groupVehiclePricing = (data) => {
	const map = new Map();

	data.forEach(item => {
		const key = [
			item.clientId ?? 'null',
			item.activityItemId,
			item.vendorId
		].join('_');

		if (!map.has(key)) {
			map.set(key, {
				clientId: item.clientId ?? null,
				activityItemId: item.activityItemId,
				lotId: item.lotId,
				allLots: item.allLots,
				allTenantLots: item.allTenantLots,
				price: item.price,
				vendorId: item.vendorId,
				vehicleTypeIds: item.vehicleTypeIds ?? null,
				vehicleTypeIdsList: item.vehicleTypeIdsList ?? null,
				vehicleTypeMargin: []
			});
		}

		const group = map.get(key);

		if (item.vehicleTypeIdsList && item.vehicleTypeIdsList.length > 0) {
			item.vehicleTypeIdsList.forEach(id => {
				group.vehicleTypeMargin.push({
					id,
					price: item.price
				});
			});
		}
		else {
			group.vehicleTypeMargin.push({
				id: DEFAULT_LABEL,
				price: item.price
			});
		}
	});
	
	return Array.from(map.values());
};
